import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-folder-portal",
  "use": "icon-leo-folder-portal-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-folder-portal\">\r\n<g transform=\"translate(-113.571 -94.022) scale(1.221818)\">\r\n<path d=\"M160 224h288l64 64h352v480H160V224zm96 160v288h512V384H256z\" />\r\n  <path d=\"M352 480h128v64H352v-64zm192 0h192v64H544v-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-folder-portal.svg
// module id = HU5P
// module chunks = 409